module.exports = __webpack_public_path__ + "img/fаlag-sp.308efb3d.svg";